import React, { useState, useRef, useCallback, useEffect } from 'react';
import moment from 'moment';
import { startCase } from 'lodash';
import { Grid, Typography, Box, useTheme } from '@mui/material';

import useScreenSizeWidth from './useScreenSizeWidth';
import AirlineFilters from './AirlineFilters';
import ResultsState from './ResultsState';
import { getResultsStyles } from './resultsStyles';

const ThreeDaysContainer = ({ children, sxContainer }) => (
  <Box sx={{ ...sxContainer, marginBottom: '3.5vh' }}>{children}</Box>
);

const ThreeDays = ({ tripType, isInUSD }) => {
  const [version, setVersion] = useState(0);
  const [prevAirlinesJson, setPrevAirlinesJson] = useState(
    JSON.stringify(window.vthws?.airlines?.airlines)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const currentJson = JSON.stringify(window.vthws?.airlines?.airlines);
      if (currentJson !== prevAirlinesJson && version > -1) {
        setPrevAirlinesJson(currentJson);
        setVersion(v => v + 1); // fuerza re-render
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [prevAirlinesJson, version]);

  const { search_type } = tripType;
  const bottomArrayLength = { OneWay: 5, RoundTrip: 6 };

  const screenSizeWidth = useScreenSizeWidth();
  const [numCell, setNumCell] = useState(bottomArrayLength[search_type] - 2);
  const [touchDirection, setTouchDirection] = useState('no');

  const theme = useTheme();
  const styles = getResultsStyles(theme);

  const month = screenSizeWidth < 1700 ? 'MMM' : 'MMMM';

  const setDate = useCallback(
    date => {
      const parsedDate = moment(date, ['DD-MM-YYYY', 'YYYY-MM-DD']).locale(
        'es'
      );
      const day = startCase(parsedDate.format('dddd'));
      const months = startCase(
        parsedDate.format(`DD-${month}`).replace(/-/g, ' de ')
      ).replace(/De/g, 'de');

      return { day, months };
    },
    [month]
  );

  const setDateFormat = date =>
    moment(date, ['DD-MM-YYYY', 'YYYY-MM-DD']).format('YYYY/MM/DD');

  const props = {
    styles,
    setDate,
    setDateFormat,
    isInUSD,
    currentSearch: tripType,
  };

  const changeCell = event => setNumCell(+event.target.value);
  const touchStartX = useRef(null);

  const handleTouchStart = e => {
    touchStartX.current = e.touches ? e.touches[0].clientX : {};
  };

  const setShadow = () => setTimeout(() => setTouchDirection('no'), 500);

  const onEndHandler = e => {
    if (touchStartX?.current !== null) {
      const currentX = e.touches[0].clientX;
      const deltaX = currentX - touchStartX.current;

      if (deltaX > 0) {
        setTouchDirection('right');
        if (numCell !== 1) setNumCell(numCell - 1);
      } else if (deltaX < 0) {
        setTouchDirection('left');
        if (numCell !== bottomArrayLength[search_type]) setNumCell(numCell + 1);
      }

      setShadow();
      touchStartX.current = null;
    }
  };

  // Filter de aerolíneas
  const selectAirline = (
    <Grid sx={styles.filtersAirlines}>
      <Typography sx={{ ...styles.bestPriceText, fontSize: '18px' }}>
        Seleccionar línea aérea por preferencia.
      </Typography>
      <AirlineFilters
        flexibleSearchResult={{ carriers: window.vthws?.airlines?.airlines }}
      />
    </Grid>
  );

  return (
    <ThreeDaysContainer sxContainer={styles.threeDaysContainer}>
      <ResultsState
        touchDirection={touchDirection}
        handleTouchStart={handleTouchStart}
        onEndHandler={onEndHandler}
        search_type={search_type}
        props={props}
        numCell={numCell}
        changeCell={changeCell}
        selectAirline={selectAirline}
      />
    </ThreeDaysContainer>
  );
};

export default ThreeDays;
